import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import { CheckCircle } from 'styled-icons/fa-regular/CheckCircle'
import { TimesCircle } from 'styled-icons/fa-regular/TimesCircle'
import { InfoCircle } from 'styled-icons/fa-solid/InfoCircle'
import { ExclamationTriangle } from 'styled-icons/fa-solid/ExclamationTriangle'

class ModalAlert extends React.Component {

  close = () => this.props.onClose()

  sign = (style) => {
    switch (style) {
      case 'danger': return <TimesCircle size={20}/>
      case 'warning': return <ExclamationTriangle size={20}/>
      case 'info': return <InfoCircle size={20}/>
      default: return <CheckCircle size={20}/>
    }
  }

  render() {
    console.log('render', this.props)
    const { title, content, type } = this.props

    return (
      <Modal show={true} className={`modal-alert modal-${type}`}>
        <Modal.Header>{this.sign(type)}</Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Modal.Body>{content}</Modal.Body>
        <Modal.Footer>
          <Button bsStyle={type} onClick={this.close}>OK</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

ModalAlert.defaultProps = {
  onClose: () => {}
}

ModalAlert.propTypes = {
  onClose: PropTypes.func,
}

export default ModalAlert



// WEBPACK FOOTER //
// ./src/components/widgets/ModalAlert.js